<template>
  <div class="sidebar select-none" :class="{'isOpen': isOpen}" :style="position">
    <transition name="fade">
      <!-- @click="toggleSidebar" -->
      <div v-show="isOpen" class="sidebar__mask" :style="minHeight"></div>
    </transition>
    <div class="sidebar__content" :style="sidebarHeight" :class="{ 'opacity-50': isLoadingHotels }">
      <div class="sidebar__main pt-24">
        <div class="sidebar__block">
          <h5 class="sidebar__block__title">{{ $t('hotelStar') }}</h5>
          <!-- TODO: 點當前的星星 要退一位 -->
          <div class="sidebar__block__checkbox__wrap flex items-center" @mouseleave="starsOnHover(false)">
            <div v-for="i in 5" class="text-2xl cursor-pointer" :key="i" @click="onStarChange(i)" @mouseover="starsOnHover(i)">
              <i class="owl-rank-star" :class="starDisplay(i)"></i>
            </div>
            <div class="ml-8">{{ $t('unit.star', [$t('number')[firstStar]]) }}</div>
          </div>
        </div>
        <template v-if="options.hotelType && !options.hotelType.isDisabled">
          <div class="sidebar__block">
            <h5 class="sidebar__block__title">{{ $t('hotelType') }}</h5>
            <div class="sidebar__block__checkbox__wrap">
              <div v-for="type in options.hotelType.items" class="w-1/2" :key="type.key" :class="{'opacity-50': isLoadingHotels}">
                <div class="owl-checkbox-wrap my-8">
                  <label :for="type.key">
                    <input type="checkbox" v-model="hotelTypes" :id="type.key" :value="type.key" :disabled="isLoadingHotels">
                    <div class="owl-checkbox"></div>
                    <span :class="hotelTypes.includes(type.key) ? 'text-blue' : null">{{ type.name }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div v-for="(item, index) in options.features.items" class="sidebar__block" :key="index">
            <h5 class="sidebar__block__title">{{ $t(index) }}</h5>
            <div class="sidebar__block__checkbox__wrap">
              <div v-for="feature in item" style="min-width: 50%;" :key="feature.key" :class="{'opacity-50': isLoadingHotels}">
                <div class="owl-checkbox-wrap my-8">
                    <label :for="feature.key">
                      <input type="checkbox" v-model="features" :id="feature.key" :value="feature.key" :disabled="isLoadingHotels">
                      <div class="owl-checkbox"></div>
                      <img v-if="feature.iconUrl" :src="feature.iconUrl" :alt="feature.name + 'image'" class="w-6 h-6 mr-8 svg-grey" :class="features.includes(feature.key) ? 'svg-blue' : null">
                      <span class="capitalize" :class="features.includes(feature.key) ? 'text-blue' : null">{{ feature.name }}</span>
                    </label>
                </div>
              </div>
            </div>
          </div>
          <div class="sidebar__block">
            <h5 class="sidebar__block__title">{{ $t('priceRange') }}</h5>
            <!-- <p class="mb-16">{{ currencySign }} {{ priceRange[0] | toCurrency }} - {{ currencySign }} {{ priceRange[1] | toCurrency }} 以上</p> -->
            <div class="mt-48 mb-16" v-loading="isFetchingFiltersOptions" element-loading-spinner="owl-arrow-reload animate-spin">
              <vueSlider
                v-model="priceRange"
                :class="isDesktop ? null : 'ml-16'"
                :width="isDesktop ? '65%' : '85%'"
                :enable-cross="true"
                :tooltip="'always'"
                :dot-options="dotOptions"
                :tooltip-placement="['top', 'top']"
                :min="priceMin"
                :max="priceMax"
                :adsorb="true"
                :dotSize="[20, 20]"
                :contained="true"
                :tooltipFormatter="priceRangeToolTip"
                :minRange="1"
                :disabled="isFetchingFiltersOptions || isLoadingHotels"
                >
              </vueSlider>
            </div>
            <!-- <div class="flex items-center">
              <div class="text-sm">
                <span class="bg-grey-lighter p-8 leading-sm" style="border-radius: 4px 0 0 4px;">{{ currencySign }}</span>
                <input type="number" :value="priceRange[0]" :placeholder="$t('priceMin')" class="bg-grey-lightest p-8 leading-sm" style="border-radius: 0 4px 4px 0;">
              </div>
              <div class="mx-16 text-sm text-grey-darker">{{ $t('to') }}</div>
              <div class="text-sm">
                <span class="bg-grey-lighter p-8 leading-sm" style="border-radius: 4px 0 0 4px;">{{ currencySign }}</span>
                <input type="number" :value="priceRange[1]" :placeholder="$t('priceMax')" class="bg-grey-lightest p-8 leading-sm" style="border-radius: 0 4px 4px 0;">
              </div>
            </div> -->
          </div>
          <slot></slot>
        </template>
      </div>
      <div class="sidebar__footer px-16">
        <slot name="footer">
          <div class="flex justify-between">
            <div>
              <button class="btn btn-text btn-blue" @click="onClose" :loading="isLoadingHotels" :disabled="isLoadingHotels">{{ $t('close') }}</button>
            </div>
            <div>
              <button class="btn btn-ghost btn-grey mr-8 px-24" @click="onReset" :loading="isLoadingHotels" :disabled="isLoadingHotels">{{ $t('clear') }}</button>
              <button class="btn btn-solid btn-blue px-24" @click="submitFilters" :loading="isLoadingHotels" :disabled="isLoadingHotels">{{ $t('confirm') }}</button>
            </div>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Modal from './index.js'
import { mapActions, mapGetters, mapMutations } from 'vuex'

import vueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

import { createHelpers } from 'vuex-map-fields'
import queryTagMixins from '@/mixins/queryTag'
import datePickerMixin from '@/mixins/datePicker'
// import searchMatch from '@/components/searchMatch'

// import peopleCounts from '@/components/peopleCounts'

const { mapFields } = createHelpers({
  getterType: 'search/getField',
  mutationType: 'search/updateField'
})

export default {
  name: 'sidebar',
  props: {
  },
  mixins: [
    queryTagMixins,
    datePickerMixin
  ],
  components: {
    // searchMatch,
    vueSlider
    // peopleCounts
  },
  data () {
    return {
      isSearchMatch: false,
      isStarsHover: false,
      // owlsight: owlsight,
      composing: false,
      isOpen: false,
      top: 0,
      restList: [
        // 'adult',
        // 'child',
        // 'childAge',
        // 'roomCount',
        // 'isStock',
        // 'hotelUUID',
        // 'placeCountry',
        // 'placeCity',
        'stars',
        'hotelTypes',
        'features',
        // 'currency',
        'priceRange'
      ],
      preStateFilters: null,
      localStars: []
    }
  },
  computed: {
    ...mapFields({
      adult: 'filters.adult',
      child: 'filters.child',
      roomCount: 'filters.roomCount',
      isStock: 'filters.isStock',
      hotelUUID: 'filters.hotelUUID',
      placeCountty: 'filters.placeCountty',
      placeCity: 'filters.placeCity',
      stars: `filters.stars`,
      hotelTypes: 'filters.hotelTypes',
      features: 'filters.features',
      currency: 'filters.currency',
      priceRange: 'filters.priceRange'
    }),
    ...mapGetters({
      'search/dateRange': 'search/dateRange',
      'search/autoComplete': 'search/autoComplete',
      currencySign: 'user/currencySign',
      isLoadingHotels: 'hotels/isLoadingHotels',
      selectedCurrency: 'user/selectedCurrency',
      isFetchingFiltersOptions: 'search/isFetchingFiltersOptions',
      options: 'search/options',
      defaultFilters: 'search/defaultFilters',
      filters: 'search/filters',
      queryFilters: 'search/queryFilters',
      windowHeight: 'windowHeight',
      people: 'search/people',
      isDesktop: 'isDesktop'
    }),
    lastStar: function () {
      return _.last(this.localStars)
    },
    firstStar: function () {
      return _.first(this.localStars)
    },
    dotOptions: function () {
      return [
        {
          tooltip: this.priceRange[0] > 0 ? 'always' : 'none'
        },
        {
          tooltip: this.priceRange[1] > 0 ? 'always' : 'none'
        }
      ]
    },
    autoComplete: function () {
      return this['search/autoComplete']
    },
    displayResult: function () {
      const result = this['search/autoComplete'].result
      let display = []
      if (result.subject || result.subject_key) {
        display.push(!_.isEmpty(result.subject) ? result.subject : result.subject_key)
      }
      display.push(!_.isEmpty(result.text) ? result.text : result.key)
      return display.join(', ')
    },
    position: function () {
      return {
        top: this.top + 'px'
      }
    },
    innerHeight: function () {
      return this['windowHeight']
    },
    minHeight: function () {
      return {
        minHeight: `100%`
      }
      // return {
      //   minHeight: `calc(${this.innerHeight}px - ${this.top}px)`
      // }
    },
    sidebarHeight: function () {
      return {
        height: `100%`
      }
      // return {
      //   height: `calc(${this.innerHeight}px - ${this.top}px)`
      // }
    },
    priceMin: function () {
      return Number(this.options?.price?.min)
    },
    priceMax: function () {
      return Number(this.options?.price?.max)
    }
  },
  methods: {
    ...mapActions([
      'bodyLock',
      'search/updateDateRange',
      'hotels/fetchHotels',
      'search/fetchFilterOptions',
      'search/autoCompleteSearchUpdate',
      'search/setAutoCompleteResult',
      'search/cancelAutoComplete'
    ]),
    ...mapMutations([
      'search/SET_AUTOCOMPLETE_SEARCH_VALUE',
      'search/RESET_CHILD_AGE'
    ]),
    starsOnHover: function (i) {
      if (i) {
        this.isStarsHover = i
      } else {
        this.isStarsHover = false
      }
    },
    onStarChange: function (star) {
      const preStar = _.chain(this.localStars).cloneDeep().first().toSafeInteger().value()
      if (preStar === star) {
        this.localStars = _.concat([ String(star - 1) ], this.localStars)
      } else {
        this.localStars = []
        for (let i = 0; i <= 5; i++) {
          if (i >= star) {
            this.localStars.push(String(i))
          }
        }
      }
      this.stars = this.localStars
    },
    starDisplay: function (i) {
      // if (this.isStarsHover) {
      //   if (i <= this.isStarsHover) {
      //     return 'text-orange'
      //   } else {
      //     return 'text-grey'
      //   }
      // }
      if (!_.includes(this.localStars, String(i - 1))) {
        return 'text-orange'
      } else {
        return 'text-grey'
      }
    },
    onInputChange: function (event) {
      if (!this.composing) {
        this.searchChange(event)
      } else {
        this['search/cancelAutoComplete']()
      }
    },
    compositionEnd: function (event) {
      this.composing = false
      this.searchChange(event)
    },
    searchChange: function (event) {
      this['search/autoCompleteSearchUpdate'](event)
      this.isSearchMatch = true
    },
    selectNextItem: function () {
      if (!this.composing) {
        this.$refs.searchMatch.selectNextItem()
        this.isSearchMatch = true
      }
    },
    selectPreItem: function () {
      if (!this.composing) {
        this.$refs.searchMatch.selectPreItem()
        this.isSearchMatch = true
      }
    },
    selectTargetItem: function () {
      if (!this.composing) {
        this.$refs.searchMatch.selectTargetItem()
      }
    },
    closeSearchBox: function () {
      this.isSearchMatch = false
    },
    clearAutoCompleteResult: function () {
      this['search/setAutoCompleteResult']()
      this['search/SET_AUTOCOMPLETE_SEARCH_VALUE']()
      this.$nextTick(() => {
        this.$refs.sidebarSearchInput.focus()
      })
    },
    priceRangeToolTip: function (val) {
      return this.currencySign + this.$options.filters.toCurrency(val)
    },
    setTop: function ({ offsetHeight, offsetTop }) {
      this.top = offsetHeight + offsetTop
    },
    toggleSidebar: function (bool) {
      const toggleBool = typeof bool === 'boolean' ? bool : !this.isOpen
      console.debug('toggleSidebar', bool, typeof bool, toggleBool)

      if (!this.isLoadingHotels) {
        if (!this.isOpen) {
          this.preStateFilters = _.cloneDeep(this.filters)
        }
        this.isOpen = toggleBool
        this.bodyLock(this.isOpen)
      }
    },
    onReset: function () {
      this.restList.forEach(key => {
        if (key === 'childAge') {
          this['search/RESET_CHILD_AGE']()
        }
        this.$set(this, key, this.defaultFilters[key])
      })
      // this['search/fetchFilterOptions']()
      this.localStars = this.stars
      // this.submitFilters()
    },
    onClose: async function () {
      this.toggleSidebar()
      this.restList.forEach(key => {
        this.$set(this, key, this.preStateFilters[key])
      })
    },
    submitFilters: function () {
      // TODO: filter 在 V3 改變規則，需修正
      // this.$ga.event('search', 'Click Sidebar(advance) Button')
      window.fbq('track', 'Search', {
        content_type: 'hotel',
        search_string: this.$route.query.place || '',
        checkin_date: this.$route.query.start || '',
        checkout_date: this.$route.query.end || '',
        num_adults: Number(this.$route.query.adult) || 2,
        num_children: Number(this.$route.query.child) || 0
      })
      // GTM
      this.$gtm.trackEvent({
        event: 'onClickSearchAdvance',
        category: 'Click Sidebar(advance) Button'
      })
      // TODO remove fetchHotels inside sidebar
      const query = {
        ...this.$route.query,
        page: this.$route.query.page || null
      }

      this['hotels/fetchHotels'](query).then(res => {
        let query = {
          ...this.$route.query,
        }
        this.$router.push({
          ...this.$route,
          query
        })
        this.toggleSidebar()
      })
    },
    focusTo: function (target) {
      if (typeof target === 'string') {
        this.$nextTick(function () {
          this.$refs[target].focus()
        })
      }
    }
  },
  created () {
    // this['search/fetchFilterOptions']()
    this.localStars = this.stars
  },
  mounted () {
    window.addEventListener('keyup', (event) => {
      // If  ESC key was pressed...
      if (this.isOpen && event.keyCode === 27) {
        this.toggleSidebar()
      }
    })
  },
  beforeMount () {
    Modal.event.$on('toggle', this.toggleSidebar)
    Modal.event.$on('set', this.setTop)
    Modal.event.$on('focus', this.focusTo)
  },
  beforeDestroy () {
    Modal.event.$off('toggle', this.toggleSidebar)
    Modal.event.$off('set', this.setTop)
    Modal.event.$off('focus', this.focusTo)
  }
}
</script>

<style lang="sass" scoped>
.sidebar
  @apply fixed w-full border-t border-grey-lightest
  z-index: 999
  left: 0
  &.isOpen
    @apply h-full
    .sidebar__content
      right: 0
      // right: -1rem
      // @screen md
      //   right: 0
  &__mask
    @apply absolute bg-black opacity-25
    top: 0
    left: 0
    width: 100vw
  &__content
    @apply absolute shadow bg-white ease opacity-100
    @apply flex flex-col justify-between
    right: calc(-100% - 1rem)
    top: 0
    width: 664px
    max-width: 100vw
    -webkit-overflow-scrolling: touch
  &__main
    @apply px-16
    height: 100%
    overflow-y: auto
  &__block
    @apply border-b border-grey-lightest py-24 pt-0 pb-16 mb-16
    &:last-child
      @apply border-0
    &__title
      @apply text-sm text-grey-darker font-bold mb-16 mt-0
    &__checkbox__wrap
      @apply flex flex-wrap
      .owl-checkbox-wrap
        @apply mr-16
    .star-wrap
      i
        @apply text-grey-dark
        &.active
          @apply text-orange
  &__search
    &__wrap
      @apply text-center
      .input
        @apply w-full flex items-center justify-between
        i
          @apply text-2xl text-grey
        input
          @apply flex-auto
    &__tag
      @apply text-sm
      &__row
        @apply flex flex-wrap flex-auto items-center
  &__footer
    @apply text-right pt-8 pb-8 border-t border-grey-lightest
.fade-leave
  opacity: .25
.fade-leave-active
  transition: all ease-out .05s
.fade-leave-to
  opacity: 0
  transform: translateX(-300px)
.fade-enter
  opacity: 0
  transform: translateX(-300px)
.fade-enter-active
  transition: all ease-out .08s
.fade-enter-to
  opacity: .25
.owl-rank-star
  &:hover
    &:before
      @apply ease
      transform: scale(1.2)
</style>
<style lang="sass">
.vue-slider-dot-handle
  @apply border-blue border-2
</style>
